import { CloudUpload, ScanEye, Ruler } from "lucide-react";
import { useAtom } from "jotai";
import { useTransfersArtworksForm } from "@design-lab/entities/transfers/model/useTransfersArtworksForm";
import {
  transfersManagerAtom,
  transfersManagerMachine,
  type TransfersTab
} from "./transfers-manager.machine";

const iconMap = {
  CloudUpload: <CloudUpload className="size-6" />,
  ScanEye: <ScanEye className="size-6" />,
  Ruler: <Ruler className="size-6" />
};

export type AppTab = {
  title: string;
  mobileTitle: string;
  value: TransfersTab;
  icon: React.ReactNode;
  valid?: boolean;
  enabled?: boolean;
  checked?: boolean;
};

export function useTab() {
  useTransfersArtworksForm();

  const [state, send] = useAtom(transfersManagerAtom);

  // Get tabs from machine selector
  const { currentTab, tabs } = transfersManagerMachine.selectors.tabs(state);

  const setTab = (tab: TransfersTab) => {
    send({ type: "tab.change", tab });
  };

  // Map icon strings to components
  const tabsWithIcons: AppTab[] = tabs.map((tab: any) => ({
    ...tab,
    icon: iconMap[tab.icon as keyof typeof iconMap]
  }));

  return {
    tabs: tabsWithIcons,
    tab: currentTab,
    setTab
  };
}
